module.exports = __webpack_public_path__ + "img/b7.8c2fa142.jpg";